<template>
  <img :src="dataUrl" />
</template>

<script>
export default {
  created() {
    let canDom = document.createElement('canvas');
    canDom.id = 'ksCanvas';
    canDom.setAttribute('width', '160px');
    canDom.setAttribute('height', '64px');
    canDom.setAttribute('style', 'display: none');
    document.body.appendChild(canDom);
    this.canvas = canDom;
  },
  mounted() {
    this.renderImg();
  },
  destroyed() {
    document.body.removeChild(this.canvas);
  },
  props: {
    value: String,
  },
  data() {
    return {
      dataUrl: '',
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.renderImg();
      }
    },
  },
  methods: {
    renderImg() {
      const ctx = this.canvas.getContext('2d');
      ctx.fillStyle = '#6180f4';
      ctx.fillRect(0, 0, 160, 64);
      ctx.font = '60px arial';
      // 创建渐变
      var gradient = ctx.createLinearGradient(0, 0, 160, 0);
      gradient.addColorStop('0', 'magenta');
      gradient.addColorStop('0.5', 'yellow');
      gradient.addColorStop('1.0', 'red');
      // 用渐变填色
      // ctx.strokeStyle = gradient;
      ctx.fillStyle = gradient;
      let height = 50;
      if (this.value) {
        //画布上添加验证码
        this.value.split('').map((val, index) => {
          ctx.save();
          ctx.rotate(((Math.random() - 0.5) * 20 * Math.PI) / 180);
          ctx.fillText(val, index * 40, height);
          ctx.restore();
        });
        // 添加干扰线
        [
          // '#f2ce19',
          '#ea639e',
          '#a14c63',
          // '#fed5d6',
        ].map((color, index) => {
          ctx.save();
          ctx.fillStyle = color;
          ctx.translate(
            80 + (Math.random() - 0.5) * 20,
            32 + (Math.random() - 0.5) * 20
          );
          ctx.rotate(((Math.random() - 0.5) * 100000 * Math.PI) / 180);
          ctx.fillRect(80 * index, 0, 300, 2);
          ctx.fillRect(80 * index, 0, -300, 2);
          ctx.restore();
        });
      }
      this.dataUrl = this.canvas.toDataURL();
    },
  },
};
</script>
